export default __webpack_public_path__ + "static/media/07_emoji-smile.498162a3.png";